<div id="personal-de-tab" class="personal-de-tab">
    <div class="block-looper">
        <h2>
            Personal de contacto
            <button *ngIf="permissionList.includes('44')" mat-button (click)="addOrEdit(null)">
                <mat-icon>add</mat-icon>
            </button>
        </h2>
        <div class="table-view">
            <table mat-table [dataSource]="dataSource">
                <caption></caption>
                <ng-container matColumnDef="Empresa">
                    <th mat-header-cell *matHeaderCellDef>Empresa</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.empresaNombre }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Nombre">
                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.nombre }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Cargo">
                    <th mat-header-cell *matHeaderCellDef>Cargo</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.cargo }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Email">
                    <th mat-header-cell *matHeaderCellDef>Email</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.email }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Telefono">
                    <th mat-header-cell *matHeaderCellDef>Telefono</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.telefono }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Movil">
                    <th mat-header-cell *matHeaderCellDef>Movil</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.movil }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Comentarios">
                    <th mat-header-cell *matHeaderCellDef>Comentarios</th>
                    <td mat-cell *matCellDef="let element" matTooltipPosition="left" matTooltip="{{ element.comentarios }}" aria-label="">
                        {{ element.comentarios }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Options">
                    <tr>
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="permissionList.includes('44')">
                                <button *ngIf="element.empresaId === selectedCompanyId" mat-button
                                    (click)="deleteContact(element)">
                                    <mat-icon>delete_forever</mat-icon>
                                </button>
                                <button *ngIf="element.empresaId === selectedCompanyId" mat-button
                                    (click)="addOrEdit(element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </div>

                        </td>
                    </tr>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"
                    [ngClass]="{ selected: row.empresaId === selectedCompanyId }"></tr>
            </table>
        </div>
    </div>
</div>